export const trackGTMEvent = <
  Events extends string | number,
  Params extends { [key in Events]?: unknown },
  NeededParams = Events extends keyof Params ? Params[Events] : never,
>(
  event: Events,
  properties?: NeededParams,
  options: {
    spreadProperties?: boolean;
  } = {},
) => {
  if (!window || !window.dataLayer) {
    return;
  }
  // Reset the dataLayer so properties are not recursively merged with
  // the properties of any events that were pushed previously.
  // See https://github.com/google/data-layer-helper
  window.dataLayer.push({ event: 'Reset DataLayer', properties: null });

  if (options.spreadProperties) {
    window.dataLayer.push({ event, ...(properties || {}) });
  } else {
    window.dataLayer.push({ event, properties: properties || {} });
  }
};
